import { CardExpiryElement } from '@stripe/react-stripe-js';
import { FormattedMessage } from 'react-intl';

import styles from './LinkDebitCard.module.css';
import { stripeElementStyles } from './StripeElementStyles';

export const ExpiryDateQuestion = ({
    error,
    onChange
}: {
    error: boolean | null;
    onChange: (response: any) => void;
}) => {
    return (
        <div className={styles.expiryDateWrapper}>
            <label className={styles.label}>
                <FormattedMessage
                    id="_.link_debit_card.expiry_date"
                    defaultMessage="Expiry date"
                />
            </label>
            {error && (
                <span className={styles.error}>
                    <FormattedMessage
                        id="_.link_debit_card.expiry_date_error"
                        defaultMessage="Invalid expiry date"
                    />
                </span>
            )}
            <CardExpiryElement
                onChange={onChange}
                options={{ style: stripeElementStyles }}
            />
        </div>
    );
};
